import { render } from "./trails.vue?vue&type=template&id=66ca5f27&ts=true"
import script from "./trails.vue?vue&type=script&lang=ts"
export * from "./trails.vue?vue&type=script&lang=ts"

import "./trails.vue?vue&type=style&index=0&id=66ca5f27&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__